module.exports = __webpack_public_path__ + "img/expDP.211ab99a.svg";